import { forwardRef, createElement } from 'react';

function IconMenu(props, svgRef) {
  return createElement("svg", Object.assign({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M4 19h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm0-6h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zM3 6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1z",
    fill: "currentColor"
  }));
}

var Menu = /*#__PURE__*/forwardRef(IconMenu);

export default Menu;
//# sourceMappingURL=Menu.js.map
